export default __webpack_public_path__ + "static/media/boy3.db82898f.jpg";